import { ArpeggioPadsRow } from "./ArpeggioPadsRow"

export const ArpeggioPadsCard = props => {
  const activePads = props.activePads
  const stepsAmount = activePads[0].length
  const padsIndexes = props.padsIndexes
  const activeCursor = props.activeCursor

  let padsCardContainerClassName = ""
  let padsCardContainerId = ""

  switch(props.padsType) {
    case "instruments":
      padsCardContainerClassName = "arpeggioInstrumentsPadsCardContainer"
      padsCardContainerId = "arpeggioInstrumentsPadsCardContainer"
      break

    case "drums": 
      padsCardContainerClassName = "arpeggioDrumsPadsCardContainer"
      padsCardContainerId = "arpeggioDrumsPadsCardContainer"
      break

    default: break
  }
  
  return (
    <div className={padsCardContainerClassName} id={padsCardContainerId} >
      {activePads.map((row, index) => {
        return (
          <ArpeggioPadsRow rank={row} index={index} activeBtns={activePads[index]} padsIndexes={padsIndexes[index]} activeCursor={activeCursor[index]} handleClick={props.handleClick} stepsAmount={stepsAmount} key={index} justCleared={props.justCleared[index]} handlePointer={props.handlePointer} handleDragEnter={props.handleDragEnter} edition={props.edition} padsType={props.padsType} />
        )
      })}
    </div>
  )
}